import { UserType } from '../../api/users/index.js';
import UserModalNew from '../UserModalNew/index.jsx';
import type { UserModalViewType } from '../UserModalNew/userModal.types.js';
import type { UserModalType } from '../UserModalNew/validation.js';
import { HandleSubmitPramsType } from './userModal.types.js';

type Props = {
  className?: string;
  onClose: () => void;

  onSubmit: (
    params: HandleSubmitPramsType,
  ) => Promise<UserType | null | undefined>;
  initialValues?: Partial<UserType>;
  isActive: boolean;
  isReadonlyPermission: boolean;
  isUserExistInWorkspace?: boolean;
  setIsUserExistInWorkspace?: (value: boolean) => void;
  initialView?: UserModalViewType;
  isTagsLoading?: boolean;
};

const UserModal = ({
  onClose,
  onSubmit,
  initialValues = {},
  isActive,
  isReadonlyPermission,
  initialView,
  isTagsLoading,
}: Props) => {
  return (
    <UserModalNew
      onClose={onClose}
      // TODO fix type after release
      onSubmit={onSubmit as any}
      initialValues={initialValues as UserModalType}
      initialTags={initialValues.tags || null}
      isActive={isActive}
      isReadonlyPermission={isReadonlyPermission}
      initialView={initialView}
      isTagsLoading={isTagsLoading}
    />
  );
};

export default UserModal;
